<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas13bg.svg" />
    <img
      id="bees"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCasBees.svg"
    />
    <img
      id="ducks"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCasDucks.svg"
    />
    <img
      id="ants"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCasAnts.svg"
    />

    <span class="normalTheme pageInstruction" style="left: 82px; top: 122px">
      <p>Ordena las letras y escribe los nombres.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 82px; top: 165px">
      <p>Usando las flechas busca el elemento que usó en la prueba.</p>
    </span>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="100"
      id="inputField01Disabled"
      defaultText="ABEJAS"
      disabled
    />
    <image-option-slider
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="slider01"
      ref="imageSlider1"
      style="width: 200px; height: 170px; margin-left: 790px; margin-top: 205px"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
    <image-option-slider
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="slider02"
      ref="imageSlider2"
      style="width: 200px; height: 170px; margin-left: 790px; margin-top: 390px"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <image-option-slider
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="slider03"
      ref="imageSlider3"
      style="width: 200px; height: 170px; margin-left: 790px; margin-top: 590px"
    />
  </div>
</template>

<style scoped>
#bg {
  position: absolute;
  left: 80px;
  top: 42px;
  z-index: -1;
}
#inputField01Disabled {
  position: absolute;
  width: 276px;
  left: 445px;
  top: 270px;
}
#inputField01 {
  position: absolute;
  width: 276px;
  left: 445px;
  top: 455px;
}
#inputField02 {
  position: absolute;
  width: 276px;
  left: 445px;
  top: 655px;
}
#bees {
  position: absolute;
  left: 18px;
  top: 230px;
}
#ducks {
  position: absolute;
  left: 5px;
  top: 427px;
}
#ants {
  position: absolute;
  left: 30px;
  top: 608px;
}
</style>

<script>
export default {
  data() {
    return {
      options: [
        "sordocas/assets_p13/key.svg",
        "sordocas/assets_p13/princesses.svg",
        "sordocas/assets_p13/pearl.svg",
      ],
    };
  },
  mounted() {
    this.$refs.imageSlider1.loadOptions(this.options);
    this.$refs.imageSlider2.loadOptions(this.options);
    this.$refs.imageSlider3.loadOptions(this.options);
  },
};
</script>